import { AuthConfig, OAuthModuleConfig } from 'angular-oauth2-oidc';
import { environment } from 'src/environments/environment';
import { getWindow } from 'ssr-window';

export const authConfig: AuthConfig = {
  issuer: environment.oauthIssuer,
  clientId: environment.oauthClientId,
  responseType: 'code',
  redirectUri: getWindow().location.origin + '/',
  scope: `openid ${environment.oauthClientId} profile email`, // profile email api Ask offline_access to support refresh token refreshes 
  clearHashAfterLogin: false, // https://github.com/manfredsteyer/angular-oauth2-oidc/issues/457#issuecomment-431807040,
  nonceStateSeparator: 'semicolon', // Real semicolon gets mangled by Duende ID Server's URI encoding
  strictDiscoveryDocumentValidation: false,
  useSilentRefresh: false, // Needed for Code Flow to suggest using iframe-based refreshes
  // silentRefreshRedirectUri: window.location.origin + '/silent-refresh.html',
  // silentRefreshTimeout: 5000, // For faster testing
  // timeoutFactor: 0.25, // For faster testing
  // sessionChecksEnabled: true,
  // showDebugInformation: true
};

export const authModuleConfig: OAuthModuleConfig = {
  resourceServer: {
    allowedUrls: [environment.baseDomain],
    sendAccessToken: true,
  }
};
